export default "__VITE_ASSET__225c110d__"